import type { PaymentFailedSocketEvent } from "./payment-failed.socket-event";
import type { PaymentFulfilledSocketEvent } from "./payment-fulfilled.socket-event";
import type { PaymentPendingSocketEvent } from "./payment-pending.socket-event";
import type { PaymentRefundFailedSocketEvent } from "./payment-refund-failed.socket-event";
import type { PaymentRefundFulfilledSocketEvent } from "./payment-refund-fullfilled.socket-event";
import type { PaymentRefundPendingSocketEvent } from "./payment-refund-pending.socket-event";
import {
    paymentSocketEventNamespace,
    paymentSocketEventTypeNames,
} from "./payment-socket-event-type-name";

type PaymentSocketEvent =
    | PaymentFailedSocketEvent
    | PaymentFulfilledSocketEvent
    | PaymentRefundPendingSocketEvent
    | PaymentRefundFailedSocketEvent
    | PaymentRefundFulfilledSocketEvent
    | PaymentPendingSocketEvent;

type PaymentSocketEventType = PaymentSocketEvent["type"];

const paymentSocketEventTypes = paymentSocketEventTypeNames.map(
    name => `${paymentSocketEventNamespace}:${name}`,
) as PaymentSocketEventType[];

export { paymentSocketEventTypes };
export type { PaymentSocketEvent, PaymentSocketEventType };
